export function decodeBase64Url(encodedUrl) {
  // Decode the base64-encoded URL
  const decodedUrl = atob(encodedUrl);

  // Parse the decoded URL to extract URL parameters
  const urlParams = new URLSearchParams(decodedUrl);

  // Initialize an object to store the parameter values
  const result = {};

  // Iterate through all the URL parameters and add them to the result object
  for (const [param, value] of urlParams) {
    result[param] = value;
  }

  return result;
}
